<template>
    <!-- 
    1.화면ID    : MCP_CL_002
    2.화면명    : 회사 분류체계관리 등록
    3.작성자    : 손승완 대리
    4.화면설명  : 거래업체애 대한 분류체계 등록 수정 기능 화면 (분류체계 엑셀 업로드 기능)
    * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
    -->
  
    <div class="content-wrap">
      <div class="d-flex justify-content-between">
        <div></div>
        <div class="table-btn-group">
          <ElButton type="excelDownload" @buttonClick="excelDown()">엑셀다운</ElButton>
        </div>
      </div>
      <ExcelManage v-show="false" ref="excelManage" />
      <div class="table-responsive table-list">
        
        <TreeTable ref="treeTableRef" :data-list="state.gridRowData" :grid-column="state.gridColumn"
          :root-val="''" :useCheckBox="true"/>
        </div> 
        <div class="text-end py-2">  
          <!-- <ElButton type="primary" @buttonClick="openModal('upload')">일괄등록</ElButton> -->
          <!-- <ElButton class="btn btn-sm btn-code" @click="getDataList()">검색</ElButton> -->
          <ElButton type="primary" @buttonClick="goBack()">이전</ElButton>
          
        </div>
  
    </div>
  
    <ExcelUploadModal ref="excelUploadModal" :colDefs="state.excelModalColDefs" />
  
  </template>
  
  <script setup>
  
  import { reactive, ref, onBeforeMount, computed } from 'vue'
  import TreeTable from "@/components/common/TreeTable.vue";
  import ExcelManage from '@/components/common/MCO_EX_001.vue'
  import { useRouter } from "vue-router";
  import ExcelUploadModal from '@/components/common/modal/ExcelUploadModal.vue';
  import { useUserStore } from '@/store/user'
  const userStore = useUserStore()
  
  
  import { useLoading } from '@/composable/Loading.js'
  const { setIsLoading } = useLoading()
  import { classList, classInst,classEdit,classDelete,getRevIdList } from '@/api/comp';
  
  const excelManage = ref(null);
  const excelUploadModal = ref(null);
  const router = useRouter();
  const treeTableRef = ref()
  onBeforeMount(async() => {
    await getMaxRev()
    getDataList();
  })
  
  //변수 선언 영역 
  const state = reactive({
    selectRows: [],
    revidList : [],
    maxRevid : '',
    //컬럼 셋팅
    gridColumn: [
      {
        header: "회사분류명",
        field: "class_nm",
        style: { width : '20%' },
        expander: true,
        type: 'text'
      },
      { header: '활성화여부', field: "enable_yn", type: 'select', cdGr: 'YN_CD', chkEss: 'Y', style:  { width : '20%' }},
      { header: '메모', field: "note", type: 'text', style:  { width : '26.5%' }},
      { header: '등록일자', field: "fmt_upd_dt" , style:  { width : '15%' }},
      { header: '수정일자', field: "fmt_upd_dt" , style:  { width : '15%' }},
  
    ],
    gridRowData: [],
  
    excelModalColDefs: [
      { headerName: '1단계', field: "up_class_id" },
      { headerName: '2단계', field: "class_id" },
      { headerName: '3단계', field: "class_nm" },
      { headerName: '4단계', field: "" },
      { headerName: '활성화여부', field: "enable_yn" },
      { headerName: '메모', field: "note" },
      { headerName: '정렬순번', field: "sort_ord" },
      { headerName: '수정일자', field: "fmt_upd_dt" },
  
    ],
  
    updateCheck: false
  
  });
  
  async function getMaxRev(){
    try{
      setIsLoading(true)
      const res = await getRevIdList()
      state.revidList = [...res.rtn]
          
      state.revidList.forEach((item) => {
        let rev_id = item.rev_id.substr(2);
        let maxrevIdVal = state.maxRevid.substr(2);
        if (rev_id > maxrevIdVal) {
          state.maxRevid = item.rev_id;
        }
      })
    }catch(e){
      console.log(e)
    }finally{
      setIsLoading(false)
    }
  }
  const getDataList = async () => {
    try {
      setIsLoading(true)
      const res = await classList()
      state.selectRows = []
      state.gridRowData = [...res.rtn]
      if(state.gridRowData.length > 0) state.maxRevid = state.gridRowData[0].rev_id
    } catch (err) {
      console.log("/comp/compList ERROR!! => " + err)
      alert("api 에러 발생!!")
    } finally {
      setIsLoading(false)
    }
  };
  
  const allCheck = computed({
    get() {
      return state.gridRowData.length === state.selectRows.length;
    },
    set(newValue) {
  
      state.selectRows = newValue
        ? state.gridRowData.map((item) => {
          return item.index;
        })
        : [];
    },
  });
  
  //행추가 함수
  async function addRow(){
    try {
      setIsLoading(true)
      //선택된 행 정보(새로 생성될 자식row에 부모id값 매칭을 위해 필요)
      let selectRows = treeTableRef.value.selectRows
      if (Object.values(selectRows).length > 0) {
        for (let row of Object.values(selectRows)) {
          if (row) {
            let params = {
              rev_id: state.maxRevid,
              up_class_id: row,
              class_nm: "New Row",
              enable_yn: "Y",
              note: "New Row",
              ss_user_id: userStore.user.employeeId,
            };
            const res = await classEdit(params)
          }
        }
      }else{
        let params = {
          rev_id: state.maxRevid,
          up_class_id: '',
          class_nm: "New Row",
          enable_yn: "Y",
          note: "New Row",
          ss_user_id: userStore.user.employeeId,
        };
        const res = await classEdit(params)
      }
  
    } catch (e) {
      console.log(e);
      alert("추가에 실패했습니다.");
    } finally {
      treeTableRef.value.selectRows = []
      setIsLoading(false)
      getDataList();
    }
  };
  
  const goBack = () => {
  
    if (state.updateCheck) {
      if (confirm("저장되지 않은 데이터가 있습니다.\n뒤로 가시겠습니까?") == true) {
        router.go(-1);
      }
    } else {
      router.go(-1);
    }
  
  }
  
  
  //등록완료 함수
  const saveRow = async () => {
    if(state.gridRowData.length <= 0){
      alert('저장할 데이터가 없습니다.')
      return
    }
      let dataListx = [];
      dataListx = state.gridRowData
      let params = {
        companyClassListVO: dataListx,
      }
  
      if (params.companyClassListVO.length > 0) {
        try {
          setIsLoading(true)
          const res = await classInst(params)
          alert('수정 완료하였습니다')
  
        } catch (err) {
  
          console.error('error', err)
          alert('코드 등록&수정 에러')
  
        } finally {
          treeTableRef.value.selectRows = []
          setIsLoading(false)
          getDataList()
        }
      }
  
  
  
  };
  
  // 삭제 함수 : 화면단 표면적 Remove 처리 
  async function deleteRow(data){
    try{
      if (confirm("선택하신 항목을 삭제 하시겠습니까?")) {
        setIsLoading(true)
  
        let selectRows = treeTableRef.value.selectRows
        if (Object.values(selectRows).length > 0) {
          for (let row of Object.values(selectRows)) {
            if (row) {
              let data = {
                rev_id : state.maxRevid,
                class_id : row
              };
              const res = await classDelete(data)
            }
          }
        }else{
          alert('선택된 행이 없습니다.')
        }
  
      }
    }catch(e){
      console.log(e)
    }finally{
      treeTableRef.value.selectRows = []
      setIsLoading(false)
      getDataList()
    }
  
  };
  
  const excelDown = () => {
    let fileNm = '회사분류체계 리스트';
    let header = state.gridColumn
    let dataList = state.gridRowData
  
    if (dataList < 1) {
      alert('엑셀로 전환할 데이터가 없습니다.');
      return false;
    }
  
    excelManage.value.excelDownload(fileNm, header, dataList)
  
  }
  
  const openModal = (modal) => {
    if (modal == 'upload') {
      excelUploadModal.value.openModal();
    }
  
  }
  
  // const onCellEditComplete = (code) => {
  //   let { data, newValue, field, newData } = code;
  
  //   data[field] = newValue
  
  //   state.selectRows.push(newData.index)
  // };
  
  //셀 수정 완료시
  const onCellEditComplete = (slotProps) => {
    state.gridRowData = state.gridRowData.map((item) => {
      if (item.class_id === slotProps.node.key) {
        item.editCell = new Object()
        if(slotProps.column.key === 'class_nm') item[`${slotProps.column.key}${slotProps.node.data.level}`] = slotProps.node.data[slotProps.column.key]
        item[slotProps.column.key] = slotProps.node.data[slotProps.column.key]
        let checkExist = treeTableRef.value.selectRows.filter(treeItem => treeItem === item.class_id)
        if (checkExist.length === 0) {
          treeTableRef.value.selectRows.push(item.class_id)
        }
      }
  
      return item
    })
  };
  
  const editCell = (obj) => {
    state.gridRowData = state.gridRowData.map((item) => {
      if (item.class_id === obj.key) {
        item.editCell = new Object()
        item.editCell[obj.col] = true
  
      }
      return item
    })
  }
  
  </script>
  